import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { LegalGuaranteeOfConformityModalBody } from './elements/LegalGuaranteeOfConformityModalBody'
import { LegalGuaranteeOfConformityModalFooter } from './elements/LegalGuaranteeOfConformityModalFooter'

const LegalGuaranteeOfConformityModalComponent = ({ ...modalProps }: ModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal {...modalProps} size="s">
      <Modal.Header
        title={t('settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.title')}
      />
      <LegalGuaranteeOfConformityModalBody />
      <LegalGuaranteeOfConformityModalFooter id={modalProps.id} />
    </Modal>
  )
}

export const LegalGuaranteeOfConformityModal = withModalConditionalRender(LegalGuaranteeOfConformityModalComponent)
